import { Button, Grid, IconButton, Typography } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import AtlasPanel from "../../atlas/blades/AtlasPanel";

const DatasetProcess: React.FC<any> = ({
  theme,
  project,
  dataset,
  process,
  onShowLogs,
  onShowParameters,
}) => {
  if (process === null) return <Fragment />;

  const [sourceDatasetLink, setSourceDatasetLink] = useState("");
  const [documentationLink, setDocumentationLink] = useState("");

  useEffect(() => {
    if (dataset.hasOwnProperty("sourceDatasets") & dataset.sourceDatasets) {
      setSourceDatasetLink(
        `/portal/dataset/${dataset.sourceDatasets[0]}/project/${project.id}`
      );
    }
  }, [dataset]);

  useEffect(() => {
    if (
      process.hasOwnProperty("documentationUrl") &&
      process.documentationUrl
    ) {
      setDocumentationLink(process.documentationUrl);
    }
  }, [process]);

  return (
    <AtlasPanel title="Provenance" height="400px">
      <Grid item xs={12} className="portalCopy">
        This dataset was generated by executing the {process.name} process.
        <br /> Click the following links for details:
      </Grid>
      <Grid container spacing={1} style={{ fontSize: 13, marginTop: "20px" }}>
        <Grid item>
          <Button
            variant="outlined"
            href={sourceDatasetLink}
            style={{ width: "170px" }}
            disabled={sourceDatasetLink === ""}
          >
            Source Dataset
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="outlined"
            href={sourceDatasetLink}
            style={{ width: "170px" }}
            disabled={sourceDatasetLink === ""}
          >
            Workflow Code
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="outlined"
            style={{ width: "170px" }}
            onClick={onShowParameters}
            disabled={documentationLink === ""}
          >
            Parameters
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="outlined"
            href={documentationLink}
            target="blank"
            style={{ width: "170px" }}
            disabled={documentationLink === ""}
          >
            Documentation
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="outlined"
            onClick={onShowLogs}
            style={{ width: "170px" }}
          >
            Execution Logs
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="outlined"
            onClick={onShowLogs}
            style={{ width: "170px" }}
          >
            Lineage
          </Button>
        </Grid>
      </Grid>
    </AtlasPanel>
  );
};

export default DatasetProcess;
